// As English is the development locale, any phrase that has the same { [key]: value }
// will be added to this array. On different locales, these must exists in the translations file:

const exactTranslations = [
  // Common
  'Kanban',
  'List View',
  'Settings',
  'Rename',
  'Cancel',
  'Create',
  'View',
  'Delete',
  'Color',
  'Description',
  'Unassigned',
  'Automatic',
  'User',
  'Percentage',
  'Save',
  '+ Add',
  'Remove',
  'Next',
  'Get Started',
  
  // Navigation
  'Leads',
  'Reports',
  'Users',
  'Business',
  'User Management',
  'Business Settings',
  'Switch Organization',
  'Sign Out',
  'Profile & Notifications',
  'Plan & Billing',
  'Organization Settings',
  'Categories',
  'Archived',
  
  // Auth
  'Log In',
  'Sign Up',
  'Email address',
  'Password',
  'Forgot your password?',
  'Language',
  'Please enter a valid email',
  'First name',
  'Last name',
  'Change password',
  'Change email',
  'Save Changes',
  'Profile Details',
  'You have unsaved changes for this user',
  'All notifications and updates will be sent to this email.',
  'Enter your old password',
  'Enter your new password',
  'Your old password will no longer work',
  'New email address',
  'Get started for free',
  'You will use your new email to sign in',
  'Verify your email is typed correctly so you can receive important communications',

  // Users
  'Users & Roles',
  'Role',
  'Organization Admin',
  'Business Manager',
  'Category Manager',
  'Lead Manager',
  'Invitation Expired',
  'Invitation Pending',
  '＋ Add User',
  'Search by name or email',
  'No users match your search. <1>Clear search</1>',
  'Select a role',

  // API Errors
  'A user with this email already exists',
  'Enter a valid email address.',
  'The request could not be processed. Please refresh this page or try again',
  'Unable to log in with provided credentials.',

  // Lead Fields
  "Email",
  "Phone",
  "Name",
  "Full Name",
  "First Name",
  "Last Name",
  "Normalized Name",
  "Street Address",
  "City",
  "State",
  "Country",
  "Zip Code",
  "Gender",
  "Birthdate",
  "Custom Fields",
  "Lead",
  "Date Added",
  "Assigned To",
  "Status",
  "Source",
  'Last Updated',
  
  // Leads
  'Add Lead',
  'Filters',
  'All Time',
  'Add Filter',
  'Edit Filter',
  'contains',
  'is',

  // Dates
  "Today",
  "Yesterday",
  "Today and yesterday",
  "This week",
  "Last week",
  "This month",
  "Last month",
  "Last 7 days",
  "Last 14 days",
  "Last 30 days",
  "Last 60 days",
  "Custom",

  // Business
  'Current business',
  'Details',
  'Business name',
  '＋ Add Category',
  'Total Leads',
  'Category name updated',
  'New category created',

  // Category
  'Category Settings',
  'Category name',
  'Default Status',
  'Lead Status',
  '＋ Add Status',
  '(optional)',
  'Lead Distribution',
  'Custom Lead Distribution',
  'Edit Distribution',
  '+ Add description',

  'All incoming leads in this category will have this status assigned by default.',
  'New incoming leads are not assigned to any user by default. Users will need to manually assign each lead.',
  'New incoming leads will be randomly assigned evenly between all users who are part of this category.',
  'Incoming leads will be assigned based on a custom distribution you define.',
  'Make sure all percentages add up to 100%',
  'Incoming leads will be assigned to users according to following percentages. <1>Learn more</1>',
  'Enter a number between 0 and 100',
  'Enter a whole number (no decimals allowed)',
  'Enter a valid number',

  // Onboarding
  'Name your business',
  'Create your first category',
  "{{name}}'s Business",
  "{{name}}'s Leads",
  'Start with an empty category',
  'Manually add or import your leads.',
  'Play with a sample category',
  'Setup complete!',
  
  'Enter a name for your business. You can edit it later in your Business Settings.',
  'Categories are used to classify your leads, e.g. <1>Roofing</1> or <2>Dental Implants</2>. All plans include unlimited categories.',
  'Add a few dummy leads to test out the look and feel of Precious Leads.',
  'Enter a name for your new category. You can edit it later inside the Category’s Settings:',
  'We will create a sample category with a few leads so that you can try and test out Precious Leads.',
];

export const getExactTranslations = () => {
  const translations = {};
  exactTranslations.forEach(entry => translations[entry] = entry);

  return translations;
}
